import React from 'react'
import { ProductOption } from 'types/product'
import Translations from '@helpers/translations'
import { analytics } from '@helpers/analytics'
import { sizeChartUrl } from '@helpers/sizeChart'
import Link from '@components/ui/Link/index'
import styles from './styles.module.scss'

type QuickLinksProps = {
  type: string
  category: string
  options: ProductOption[]
}

const QuickLinks = ({ type, options, category }: QuickLinksProps) => {
  return (
    <div className={styles.productForm__quickLinks}>
      <Link
        text={Translations.localise('product.filters.size-chart')}
        href={sizeChartUrl(options, type, category)}
        onClick={() =>
          analytics('Click', {
            category: 'Product Page',
            action: 'Size Chart Link',
            label: type
          })
        }
      />
    </div>
  )
}

export default QuickLinks
